/* eslint-disable no-console,no-restricted-syntax */
import Vue from 'vue'
import App from './App.vue'
import VueMoment from "vue-moment";
import Axios from 'axios'
import Nl2br from "vue-nl2br";
import VueNoty from 'vuejs-noty'
import VueBus from 'vue-bus';
import BootstrapVue from 'bootstrap-vue';
import VueClipboard from 'vue-clipboard2';
import qrcodeVue from 'qrcode-vue';
import parser from 'fast-xml-parser';

import store from '@/store';
import router from '@/routes';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import '@/sass/app.scss';
import i18n from '@/i18n';
import VueLodash from 'vue-lodash';
var VueScrollTo = require('vue-scrollto');


Axios.defaults.withCredentials = true;
Axios.defaults.timeout = 3000;

Axios.interceptors.response.use(
    (response) => {
        console.log(router.history.current.path);
        return response;        
    },
    (error) => {
        if (error.response.status === 401) {
            store.dispatch('auth/NotAuthenticated').then(() => {                
                window.location.href = "/login?redirect=" + router.history.current.path;
            });
        }
        return Promise.reject(error)
    }
);

Vue.use(VueLodash, { name: 'lodash' }) // options is optional
Vue.use(VueBus);
Vue.use(VueMoment);
Vue.use(BootstrapVue);
Vue.use(VueClipboard);
Vue.use(qrcodeVue);

Vue.prototype.$http = Axios;
Vue.prototype.axios = Axios;
Vue.prototype.parser = parser;

Vue.use(VueBus);
Vue.use(VueNoty, {
    theme: 'relax',
    timeout: 2000,
    progressBar: true,
    layout: 'topRight'
});

Vue.use(VueScrollTo);

Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
});

Vue.component('nl2br', Nl2br);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
